<template>
  <DashboardLayout>
    <div class="d-flex align-items-center gap-2 mb-4 page-identifier">
      <!-- Dynamic Parent -->
      <router-link v-if="fromNotifications"
        :to="{ name: 'ViewPendingNotifications', query: { entityType: route.query.entityType, statusInd: route.query.statusInd } }"
        class="mb-0 main-identifier fw-semibold text-decoration-none">
        Notifications
      </router-link>

      <router-link v-else :to="{ name: 'ViewBudget', params: { id: id } }"
        class="mb-0 main-identifier fw-semibold text-decoration-none">
        Budget
      </router-link>
      <span class="material-symbols-outlined">keyboard_arrow_right</span>
      <p class="mb-0 sub-identifier">Budget Approval</p>
    </div>

    <div class="d-flex justify-content-center mb-5">

      <div class="form-outer-wrapper">
        <div class="form-outer" style="width: 1400px;">
          <form @submit.prevent="handleApprove">
            <div class="crud-form position-relative">

              <div class="form-inner mb-2">
                <div class="form-header d-flex justify-content-between align-items-center">
                  <h1 class="mb-0">Approval Form</h1>
                  <button type="button" class="btn btn-sm budget-preview-btn" @click="openBudgetPreview">
                    View Budget Details
                  </button>
                </div>

                <div class="budget-area position-relative px-4">
                  <div v-if="loadingDetails" class="loading-state text-center py-5">
                    <div class="spinner-border text-primary" role="status" aria-hidden="true"></div>
                    <p class="mt-2 mb-0 text-muted">Loading budget...</p>
                  </div>

                  <div v-if="error && !loadingDetails" class="alert alert-warning mt-3" role="alert">
                    {{ error }}
                  </div>

                  <div class="budget-title mb-4 mt-4">
                    <div class="row mb-3">
                      <!-- File Name -->
                      <div class="col-md-12 row form-group position-relative floating-label-group">
                        <div class="col-md-2 label-left d-flex justify-content-end align-items-center ">
                          <label for="fileName" class="form-label">File Name</label>
                        </div>
                        <div class="col-md-10 input-right">
                          <input id="fileName" type="text" class="form-control form-view-only-input"
                            :value="form.fileName || 'N/A'" placeholder="" readonly />
                        </div>
                      </div>
                      <!-- Budget Name -->
                      <div class="col-md-12 row form-group position-relative floating-label-group">
                        <div class="col-md-2 label-left d-flex justify-content-end align-items-center ">
                          <label for="budgetName" class="form-label">Budget Name</label>
                        </div>
                        <div class="col-md-10 input-right">
                          <input id="budgetName" type="text" class="form-control form-view-only-input"
                            :value="form.budgetName || 'N/A'" placeholder="" readonly />
                        </div>
                      </div>
                      <!-- Budget Year -->
                      <div class="col-md-12 row form-group position-relative floating-label-group">
                        <div class="col-md-2 label-left d-flex justify-content-end align-items-center">
                          <label for="year" class="form-label">Budget Year</label>
                        </div>
                        <div class="col-md-10 input-right">
                          <input id="budgetYear" type="text" class="form-control form-view-only-input"
                            :value="form.year || 'N/A'" placeholder="" readonly />
                        </div>
                      </div>
                      <!-- Created Date -->
                      <div class="col-md-12 row form-group position-relative floating-label-group">
                        <div class="col-md-2 label-left d-flex justify-content-end align-items-center">
                          <label for="qssApprovalDate" class="form-label">Created Date</label>
                        </div>
                        <div class="col-md-10 input-right">
                          <input id="qssApprovalDate" type="text" class="form-control form-view-only-input"
                            :value="formatDate(form.qssApprovalDate) || 'N/A'" placeholder="" readonly />
                        </div>
                      </div>
                      <!-- Director of Budget -->
                      <div v-if="form.dirBudgetRemark"
                        class="col-md-12 row form-group position-relative floating-label-group">
                        <div class="col-md-2 label-left d-flex justify-content-end align-items-center">
                          <label for="dirBudgetRemark" class="form-label">Director of Budget</label>
                        </div>
                        <div class="col-md-4 input-right">
                          <input id="dirBudgetRemark" type="text" class="form-control form-view-only-input"
                            :value="form.dirBudgetRemark || 'N/A'" placeholder="" readonly />
                        </div>
                        <!-- Approval Date -->
                        <div class="col-md-2 label-left d-flex justify-content-end align-items-center">
                          <label for="dirBudApprovalDate" class="form-label">Approval Date</label>
                        </div>
                        <div class="col-md-4 input-right">
                          <input id="dirBudApprovalDate" type="text" class="form-control form-view-only-input"
                            :value="formatDate(form.dirBudApprovalDate) || 'N/A'" placeholder="" readonly />
                        </div>
                      </div>
                      <!-- Permanent Secretary -->
                      <div v-if="form.permSecRemark"
                        class="col-md-12 row form-group position-relative floating-label-group">
                        <div class="col-md-2 label-left d-flex justify-content-end align-items-center">
                          <label for="permSecRemark" class="form-label">Permanent Secretary</label>
                        </div>
                        <div class="col-md-4 input-right">
                          <input id="permSecRemark" type="text" class="form-control form-view-only-input"
                            :value="form.permSecRemark || 'N/A'" placeholder="" readonly />
                        </div>
                        <!-- Approval Date -->
                        <div class="col-md-2 label-left d-flex justify-content-end align-items-center">
                          <label for="permSecApprovalDate" class="form-label">Approval Date</label>
                        </div>
                        <div class="col-md-4 input-right">
                          <input id="permSecApprovalDate" type="text" class="form-control form-view-only-input"
                            :value="formatDate(form.permSecApprovalDate) || 'N/A'" placeholder="" readonly />
                        </div>
                      </div>
                      <!-- Commissioner -->
                      <div v-if="form.commRemark"
                        class="col-md-12 row form-group position-relative floating-label-group">
                        <div class="col-md-2 label-left d-flex justify-content-end align-items-center">
                          <label for="commRemark" class="form-label">Commissioner of Budget & Planning</label>
                        </div>
                        <div class="col-md-4 input-right">
                          <input id="commRemark" type="text" class="form-control form-view-only-input"
                            :value="form.commRemark || 'N/A'" placeholder="" readonly />
                        </div>
                        <!-- Approval Date -->
                        <div class="col-md-2 label-left d-flex justify-content-end align-items-center">
                          <label for="commApprovalDate" class="form-label">Approval Date</label>
                        </div>
                        <div class="col-md-4 input-right">
                          <input id="commApprovalDate" type="text" class="form-control form-view-only-input"
                            :value="formatDate(form.commApprovalDate) || 'N/A'" placeholder="" readonly />
                        </div>
                      </div>
                      <!-- Total Budget -->
                      <div class="col-md-12 row form-group position-relative floating-label-group">
                        <div class="col-md-2 label-left d-flex justify-content-end align-items-center">
                          <label for="totalBudget" class="form-label">Total Budget</label>
                        </div>
                        <div class="col-md-10 input-right">
                          <input id="totalBudget" type="text" class="form-control form-view-only-input"
                            :value="formatCurrency(form.totalBudget || 0)" placeholder="" readonly />
                        </div>
                      </div>

                    </div>
                  </div>

                  <!-- Submit Button -->
                  <div v-if="!loadingDetails && canApprove" class="d-flex justify-content-end mt-4">
                    <div class="d-flex justify-content-end">
                      <button type="button" class="btn btn-success accept-btn me-2" @click="handleApprove"
                        :disabled="loadingApprove || submitted">
                        <span v-if="loadingApprove" class="spinner-border spinner-border-sm me-2" role="status"
                          aria-hidden="true"></span>
                        {{ loadingApprove ? 'Processing...' : 'Approve' }}
                      </button>

                      <button type="button" class="btn btn-danger reject-btn  me-2" @click="handleReject"
                        :disabled="loadingReject || submitted">
                        <span v-if="loadingReject" class="spinner-border spinner-border-sm me-2" role="status"
                          aria-hidden="true"></span>
                        {{ loadingReject ? 'Processing...' : 'Reject' }}
                      </button>
                    </div>
                  </div>

                </div>

              </div>
            </div>

          </form>

        </div>
      </div>

      <!-- Budget Preview Modal -->
      <div v-if="showBudgetPreview" class="budget-preview-overlay" @click="closeBudgetPreview">
        <div class="budget-preview-modal position-relative" @click.stop>
          <div v-if="loadingDetails" class="loading-state text-center py-5">
            <div class="spinner-border text-primary" role="status" aria-hidden="true"></div>
            <p class="mt-2 mb-0 text-muted">Loading budget details...</p>
          </div>
          <div class="budget-preview-header">
            <h5 class="mb-0">Budget Details</h5>
            <button type="button" class="btn-close" aria-label="Close" @click="closeBudgetPreview"></button>
          </div>

          <div class="budget-preview-body">
            <!-- Table Controls -->
            <div class="table-controls mt-3">
              <div class="table-controls-top">
                <div class="table-controls-left">
                  <div class="entries-control">
                    <span>Show</span>
                    <select class="form-select form-select-sm" v-model.number="pageLength">
                      <option :value="10">10</option>
                      <option :value="25">25</option>
                      <option :value="50">50</option>
                      <option :value="100">100</option>
                    </select>
                    <span>Entries</span>
                  </div>

                  <div class="search-box" style="max-width: 100%;">
                    <span class="material-symbols-outlined search-icon">search</span>
                    <input type="search" v-model="search" class="form-control form-control-sm search-input"
                      placeholder="Search by mda, economic line item, amount budgeted or revenue amount..." />
                  </div>

                </div>
              </div>
            </div>

            <!-- Table -->
            <div class="table-wrapper">
              <div class="table-container">
                <table class="responsive-table">
                  <thead>
                    <tr>
                      <th></th>
                      <th class="sortable-header">
                        <div class="th-content">
                          <span>MDA</span>
                          <div class="sort-icons">
                            <span class="material-symbols-outlined sort-icon"
                              :class="{ active: sortKey === 'mda' && sortOrder === 'asc' }"
                              @click="setSort('mda', 'asc')">
                              arrow_drop_up
                            </span>
                            <span class="material-symbols-outlined sort-icon"
                              :class="{ active: sortKey === 'mda' && sortOrder === 'desc' }"
                              @click="setSort('mda', 'desc')">
                              arrow_drop_down
                            </span>
                          </div>
                        </div>
                      </th>
                      <th class="sortable-header">
                        <div class="th-content">
                          <span>Economic Line Item</span>
                          <div class="sort-icons">
                            <span class="material-symbols-outlined sort-icon"
                              :class="{ active: sortKey === 'economic_line_item' && sortOrder === 'asc' }"
                              @click="setSort('economic_line_item', 'asc')">
                              arrow_drop_up
                            </span>
                            <span class="material-symbols-outlined sort-icon"
                              :class="{ active: sortKey === 'economic_line_item' && sortOrder === 'desc' }"
                              @click="setSort('economic_line_item', 'desc')">
                              arrow_drop_down
                            </span>
                          </div>
                        </div>
                      </th>
                      <th class="sortable-header">
                        <div class="th-content">
                          <span>Amount Budgeted</span>
                          <div class="sort-icons">
                            <span class="material-symbols-outlined sort-icon"
                              :class="{ active: sortKey === 'amount_budgeted' && sortOrder === 'asc' }"
                              @click="setSort('amount_budgeted', 'asc')">
                              arrow_drop_up
                            </span>
                            <span class="material-symbols-outlined sort-icon"
                              :class="{ active: sortKey === 'amount_budgeted' && sortOrder === 'desc' }"
                              @click="setSort('amount_budgeted', 'desc')">
                              arrow_drop_down
                            </span>
                          </div>
                        </div>
                      </th>
                      <th class="sortable-header">
                        <div class="th-content">
                          <span>Revenue Amount</span>
                          <div class="sort-icons">
                            <span class="material-symbols-outlined sort-icon"
                              :class="{ active: sortKey === 'revenue_amount' && sortOrder === 'asc' }"
                              @click="setSort('revenue_amount', 'asc')">
                              arrow_drop_up
                            </span>
                            <span class="material-symbols-outlined sort-icon"
                              :class="{ active: sortKey === 'revenue_amount' && sortOrder === 'desc' }"
                              @click="setSort('revenue_amount', 'desc')">
                              arrow_drop_down
                            </span>
                          </div>
                        </div>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(budget, index) in paginatedItems" :key="budget.id"
                      :class="index % 2 === 0 ? 'row-even' : 'row-odd'">
                      <td data-label="S/N" class="serial-no text-center">
                        {{ (currentPage - 1) * pageLength + index + 1 }}
                      </td>
                      <td data-label="MDA" class="primary-col fw-semibold">
                        {{ budget.mda }}</td>
                      <td data-label="Economic Line Item" class="secondary-col">
                        {{ budget.economic_line_item }}
                      </td>
                      <td data-label="Amount Budgeted" class="secondary-col fw-semibold text-end">
                        {{ formatCurrency(budget.amount_budgeted || 0) }}
                      </td>
                      <td data-label="Revenue Amount" class="secondary-col fw-semibold text-end">
                        {{ formatCurrency(budget.revenue_amount || 0) }}
                      </td>
                    </tr>

                    <tr v-if="budget.length === 0">
                      <td :colspan="5" class="text-center text-muted py-4">
                        <div>No budget to display.</div>
                      </td>
                    </tr>
                  </tbody>
                </table>

                <!-- Pagination Summary and Actions -->
                <div v-if="!loadingDetails && budget.length"
                  class="pagination-info d-flex justify-content-between align-items-center flex-wrap gap-2 mt-3 mb-1 me-1">
                  <!-- Summary -->
                  <small class="text-muted">
                    Showing
                    <strong>{{ (currentPage - 1) * pageLength + 1 }}</strong>
                    to
                    <strong>{{ Math.min(currentPage * pageLength, filteredItems.length) }}</strong>
                    of
                    <strong>{{ filteredItems.length.toLocaleString() }}</strong>
                    entries
                  </small>

                  <!-- Pagination Controls -->
                  <nav class="pagination-nav ms-1" aria-label="Page navigation">
                    <ul class="pagination pagination-sm mb-0">
                      <li class="page-item" :class="{ disabled: currentPage === 1 }">
                        <a class="page-link" href="#" @click.prevent="changePage(currentPage - 1)">Previous</a>
                      </li>
                      <li v-for="(page, index) in visiblePages" :key="index" class="page-item"
                        :class="{ active: currentPage === page, disabled: page === '...' }">
                        <a v-if="page !== '...'" class="page-link" href="#" @click.prevent="changePage(page)">
                          {{ page }}
                        </a>

                        <span v-else class="page-link">...</span>
                      </li>
                      <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                        <a class="page-link" href="#" @click.prevent="changePage(currentPage + 1)">Next</a>
                      </li>
                    </ul>
                  </nav>

                </div>

              </div>
            </div>

            <!-- Export Links-->
            <div class="export-links justify-content-end">
              <a href="#" class="export-link text-decoration-none" @click.prevent="exportToPDF()">Export to
                PDF</a>
              <a href="#" class="export-link text-decoration-none" @click.prevent="exportToExcel()">Export
                to Excel</a>
            </div>
          </div>

        </div>
      </div>
    </div>

  </DashboardLayout>
</template>

<script setup>
import { ref, onMounted, computed, watch } from 'vue'
import axios from 'axios'
import DashboardLayout from '../layout/DashboardLayout.vue'
import Cookies from 'js-cookie';
import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'
import ExcelJS from 'exceljs'
import Swal from 'sweetalert2'
import { debounce } from 'lodash'
import { useRoute, useRouter } from 'vue-router';
import { useUserStore } from '@/stores/user';
const route = useRoute()
const router = useRouter()
const userStore = useUserStore()
const id = route.params.id || route.query.id
const hasRole = (role) => !!(userStore.profile?.role || {})[role]
const canApprove = computed(() => {
  return Boolean(id) && (
    hasRole('dirOfBudget') ||
    hasRole('perSec') ||
    hasRole('commOfBAndP')
  ) && !hasApproved.value
})
const hasApproved = computed(() => {
  if (hasRole('dirOfBudget') && form.value.dirBudApprovalDate) return true
  if (hasRole('perSec') && form.value.permSecApprovalDate) return true
  if (hasRole('commOfBAndP') && form.value.commApprovalDate) return true
  return false
})
const root_api_url = process.env.VUE_APP_API_ROOT_URL
const fromNotifications = computed(() => route.query.from === 'ViewPendingNotifications' && route.query.entityType && route.query.statusInd)

const search = ref('');
const budget = ref([]);
const error = ref('');
const sortKey = ref('')
const sortOrder = ref('asc')
const setSort = (key, order) => {
  sortKey.value = key
  sortOrder.value = order
  currentPage.value = 1
}
const loadingDetails = ref(false);
const loadingApprove = ref(false);
const loadingReject = ref(false);
const submitted = ref(false);
const showBudgetPreview = ref(false);
const pageLength = ref(25);
const currentPage = ref(1);
const debouncedSearch = ref('')
watch(search, debounce((val) => {
  debouncedSearch.value = val
}, 300))

watch(pageLength, () => {
  currentPage.value = 1
})
const filteredItems = computed(() => {
  let items = budget.value

  if (debouncedSearch.value) {
    const term = debouncedSearch.value.toLowerCase()
    items = items.filter(item =>
      item.mda.toLowerCase().includes(term) ||
      item.economic_line_item.toLowerCase().includes(term) ||
      String(item.amount_budgeted).toLowerCase().includes(term) ||
      String(item.revenue_amount).toLowerCase().includes(term)
    )
  }

  if (sortKey.value) {
    items = [...items].sort((a, b) => {
      const aVal = a[sortKey.value]
      const bVal = b[sortKey.value]
      const aNum = Number(aVal)
      const bNum = Number(bVal)
      const isNumeric = !isNaN(aNum) && !isNaN(bNum)

      let result = isNumeric
        ? aNum - bNum
        : String(aVal).localeCompare(String(bVal))

      return sortOrder.value === 'asc' ? result : -result
    })
  }

  return items
})

const paginatedItems = computed(() => {
  const start = (currentPage.value - 1) * pageLength.value
  return filteredItems.value.slice(start, start + pageLength.value)
})

const totalPages = computed(() => {
  return Math.ceil(filteredItems.value.length / pageLength.value)
})

const changePage = (page) => {
  if (page >= 1 && page <= totalPages.value) {
    currentPage.value = page
  }
}

const visiblePages = computed(() => {
  const total = totalPages.value
  const current = currentPage.value
  const delta = 2 // pages around current

  const range = []
  const rangeWithDots = []

  let l

  for (let i = 1; i <= total; i++) {
    if (
      i === 1 ||
      i === total ||
      (i >= current - delta && i <= current + delta)
    ) {
      range.push(i)
    }
  }

  for (let i of range) {
    if (l) {
      if (i - l === 2) {
        rangeWithDots.push(l + 1)
      } else if (i - l > 2) {
        rangeWithDots.push('...')
      }
    }
    rangeWithDots.push(i)
    l = i
  }

  return rangeWithDots
})

const form = ref({
  id: '',
  fileName: '',
  budgetName: '',
  qssApprovalDate: '',
  year: '',
  mdaLineItemFileDtos: [],
  totalBudget: 0,
  fileEntryError: false,
  errorMessage: '',
  dirBudgetRemark: '',
  permSecRemark: '',
  commRemark: '',
  dirBudApprovalDate: '',
  permSecApprovalDate: '',
  commApprovalDate: '',
  qssId: '',
  dirBudgetId: '',
  permSecId: '',
  commId: '',
  ticketId: '',
  statusInd: 0,
})

const openBudgetPreview = () => {
  showBudgetPreview.value = true
}

const closeBudgetPreview = () => {
  showBudgetPreview.value = false
}

const fetchBudget = async () => {
  if (!id) {
    return
  }
  error.value = ''
  loadingDetails.value = true
  const token = Cookies.get('auth_token');
  try {
    const { data } = await axios.get(`${root_api_url}/eli/mda-eli-budget/budget-upload/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    form.value.id = data.id || ''
    form.value.fileName = data.fileName || ''
    form.value.budgetName = data.budgetName || ''
    form.value.qssApprovalDate = data.qssApprovalDate || ''
    form.value.year = data.year || ''
    form.value.totalBudget = data.totalBudget || 0
    form.value.fileEntryError = form.value.fileEntryError || ''
    form.value.dirBudgetRemark = data.dirBudgetRemark || ''
    form.value.permSecRemark = data.permSecRemark || ''
    form.value.commRemark = data.commRemark || ''
    form.value.dirBudApprovalDate = data.dirBudApprovalDate || ''
    form.value.permSecApprovalDate = data.permSecApprovalDate || ''
    form.value.commApprovalDate = data.commApprovalDate || ''
    if (form.value.dirBudApprovalDate) {
      form.value.dirBudgetRemark = "Approved"
    }
    if (form.value.permSecApprovalDate) {
      form.value.permSecRemark = "Approved"
    }
    if (form.value.commApprovalDate) {
      form.value.commRemark = "Approved"
    }
    form.value.qssId = data.qssId || ''
    form.value.dirBudgetId = data.dirBudgetId || ''
    form.value.permSecId = data.permSecId || ''
    form.value.commId = data.commId || ''
    form.value.ticketId = data.ticketId || ''
    form.value.statusInd = data.statusInd || 0

    budget.value = (data.mdaLineItemFileDtos || []).map(item => ({
      id: item.id || '',
      parent_id: item.parentId || '',
      mda_id: item.mdaId || '',
      mda: item.mdaName || '',
      economic_line_item_id: item.economicLineItemId || '',
      economic_line_item: item.eliName || '',
      amount_budgeted: item.amountBudgeted || 0,
      revenue_amount: item.revenueAmount || 0,
      org_code: item.orgCode || '',
      economic_code: item.economicCode || '',
      year: item.year || '',
      error_message: item.errorMessage || '',
    }))

    console.log('Budget API Response:', data)
    console.log('Fetched Budget:', budget.value)
  } catch (err) {
    console.log('Error fetching budget:', err)
    console.error('Failed to fetch Budget:', err)
    error.value = 'Failed to fetch budget. Please try again.'
  } finally {
    loadingDetails.value = false
  }
}

const handleApprove = async () => {
  const token = Cookies.get('auth_token');
  const iconHtmlSuccess = `<span class="iconify" data-icon="ci:circle-check" style="font-size: 100px; color: green;"></span>`
  const iconHtmlError = `<span class="iconify" data-icon="material-symbols:cancel-outline-rounded" style="font-size: 100px; color: red;"></span>`

  loadingApprove.value = true
  submitted.value = true

  form.value.id = form.value.id || ''
  form.value.fileName = form.value.fileName || ''
  form.value.budgetName = form.value.budgetName || ''
  form.value.qssApprovalDate = form.value.qssApprovalDate || ''
  form.value.year = form.value.year || ''
  form.value.totalBudget = form.value.totalBudget || 0
  form.value.fileEntryError = form.value.fileEntryError || ''
  form.value.dirBudgetRemark = form.value.dirBudgetRemark || ''
  form.value.permSecRemark = form.value.permSecRemark || ''
  form.value.commRemark = form.value.commRemark || ''
  form.value.dirBudApprovalDate = form.value.dirBudApprovalDate || ''
  form.value.permSecApprovalDate = form.value.permSecApprovalDate || ''
  form.value.commApprovalDate = form.value.commApprovalDate || ''
  form.value.qssId = form.value.qssId || ''
  form.value.dirBudgetId = form.value.dirBudgetId || ''
  form.value.permSecId = form.value.permSecId || ''
  form.value.commId = form.value.commId || ''
  form.value.ticketId = form.value.ticketId || ''
  form.value.statusInd = form.value.statusInd || 0

  form.value.mdaLineItemFileDtos = budget.value.map(item => ({
    id: item.id || '',
    parentId: item.parent_id || '',
    mdaId: item.mda_id || '',
    mdaName: item.mda || '',
    economicLineItemId: item.economic_line_item_id || '',
    eliName: item.economic_line_item || '',
    amountBudgeted: item.amount_budgeted || 0,
    revenueAmount: item.revenue_amount || 0,
    orgCode: item.org_code || '',
    economicCode: item.economic_code || '',
    year: item.year || '',
    errorMessage: item.error_message || '',
  }))

  try {
    const result = await axios.post(`${root_api_url}/eli/file-upload/save-file`, form.value, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    if (hasRole('dirOfBudget')) {
      form.value.dirBudgetRemark = "Approved"
    }
    if (hasRole('perSec')) {
      form.value.permSecRemark = "Approved"
    }
    if (hasRole('commOfBAndP')) {
      form.value.commRemark = "Approved"
    }

    console.log('Approve successful:', result)
    Swal.fire({
      html: `${iconHtmlSuccess}
      <h1 style="font-weight:600;">Success</h1>
      <p>MDA Budget approved successfully.</p>`,
      showConfirmButton: true,
      showCloseButton: true,
      icon: undefined,
    });
    router.push({ name: 'ViewBudget', params: { id } })

  } catch (err) {
    Swal.fire({
      html: `${iconHtmlError}
      <h1 style="font-weight:600;">Error</h1>
      <p>Unexpected error occurred while approving MDA Budget. Kindly contact administrator</p>`,
      showConfirmButton: true,
      showCloseButton: true,
      icon: undefined,
    });
    console.error('Unexpected error:', error)
    // console.log('Final payload being sent:', form.value)
    // console.log('Final budget details being sent:', budget.value)
  } finally {
    loadingApprove.value = false
    submitted.value = false
  }
}

const handleReject = async () => {
  const token = Cookies.get('auth_token');
  const iconHtmlSuccess = `<span class="iconify" data-icon="ci:circle-check" style="font-size: 100px; color: green;"></span>`
  const iconHtmlError = `<span class="iconify" data-icon="material-symbols:cancel-outline-rounded" style="font-size: 100px; color: red;"></span>`

  loadingReject.value = true
  submitted.value = true

  form.value.id = form.value.id || ''
  form.value.fileName = form.value.fileName || ''
  form.value.budgetName = form.value.budgetName || ''
  form.value.qssApprovalDate = form.value.qssApprovalDate || ''
  form.value.year = form.value.year || ''
  form.value.totalBudget = form.value.totalBudget || 0
  form.value.fileEntryError = form.value.fileEntryError || ''
  form.value.dirBudgetRemark = form.value.dirBudgetRemark || ''
  form.value.permSecRemark = form.value.permSecRemark || ''
  form.value.commRemark = form.value.commRemark || ''
  form.value.dirBudApprovalDate = form.value.dirBudApprovalDate || ''
  form.value.permSecApprovalDate = form.value.permSecApprovalDate || ''
  form.value.commApprovalDate = form.value.commApprovalDate || ''
  form.value.qssId = form.value.qssId || ''
  form.value.dirBudgetId = form.value.dirBudgetId || ''
  form.value.permSecId = form.value.permSecId || ''
  form.value.commId = form.value.commId || ''
  form.value.ticketId = form.value.ticketId || ''
  form.value.statusInd = 4

  form.value.mdaLineItemFileDtos = budget.value.map(item => ({
    id: item.id || '',
    parentId: item.parent_id || '',
    mdaId: item.mda_id || '',
    mdaName: item.mda || '',
    economicLineItemId: item.economic_line_item_id || '',
    eliName: item.economic_line_item || '',
    amountBudgeted: item.amount_budgeted || 0,
    revenueAmount: item.revenue_amount || 0,
    orgCode: item.org_code || '',
    economicCode: item.economic_code || '',
    year: item.year || '',
    errorMessage: item.error_message || '',
  }))

  try {
    const result = await axios.post(`${root_api_url}/eli/file-upload/save-file`, form.value, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    if (hasRole('dirOfBudget')) {
      form.value.dirBudgetRemark = "Rejected"
    }
    if (hasRole('perSec')) {
      form.value.permSecRemark = "Rejected"
    }
    if (hasRole('commOfBAndP')) {
      form.value.commRemark = "Rejected"
    }

    console.log('Reject successful:', result)

    Swal.fire({
      html: `${iconHtmlSuccess}
      <h1 style="font-weight:600;">Success</h1>
      <p>MDA Budget rejected successfully.</p>`,
      showConfirmButton: true,
      showCloseButton: true,
      icon: undefined,
    });
  } catch (err) {
    Swal.fire({
      html: `${iconHtmlError}
      <h1 style="font-weight:600;">Error</h1>
      <p>Unexpected error occurred while rejecting MDA Budget.</p>`,
      showConfirmButton: true,
      showCloseButton: true,
      icon: undefined,
    });
    console.error('Unexpected error:', error)
  } finally {
    loadingReject.value = false
    submitted.value = false
  }
}

const exportToPDF = () => {
  const doc = new jsPDF()
  autoTable(doc, {
    head: [['S/N', 'MDA', 'Economic Line Item', 'Amount Budgeted (₦)', 'Revenue Amount (₦)']],
    body: budget.value.map((budget, index) => [
      `${index + 1}`,
      budget.mda,
      budget.economic_line_item,
      budget.amount_budgeted,
      budget.revenue_amount
    ])
  })
  doc.save('budget.pdf')
}

const exportToExcel = async () => {
  const workbook = new ExcelJS.Workbook()
  const worksheet = workbook.addWorksheet('budget')
  worksheet.addRow(['S/N', 'MDA', 'Economic Line Item', 'Amount Budgeted', 'Revenue Amount'])

  budget.value.forEach((budget, index) => {
    const row = worksheet.addRow([
      `${index + 1}`,
      budget.mda,
      budget.economic_line_item,
      budget.amount_budgeted,
      budget.revenue_amount
    ])

    const currencyCols = [4, 5]
    currencyCols.forEach(col => {
      worksheet.getColumn(col).width = 18
      const cell = row.getCell(col)
      cell.value = Number(cell.value || 0)
      cell.numFmt = '#,##0.00'
      cell.alignment = { horizontal: 'right' }
    })
  })


  worksheet.getRow(1).font = { bold: true }

  const buffer = await workbook.xlsx.writeBuffer()
  const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
  const url = window.URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = 'budget.xlsx'
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  window.URL.revokeObjectURL(url)
}


const formatDate = (dateString) => {
  const date = new Date(dateString)
  return date.toLocaleDateString('en-US', {
    timeZone: 'UTC',
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  })
}

const formatCurrency = (amount) => {
  return '₦' + Number(amount || 0).toLocaleString('en-NG', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })
}

onMounted(async () => {
  if (!userStore.profile) {
    await userStore.fetchProfile()
  }

  await fetchBudget(),
  document.title = "Budget Approval"
})

</script>
<style scoped>
.view-only-input {
  background-color: transparent;
  cursor: default;
  pointer-events: none;
  color: #212529;
  font-size: 1rem;
  padding-right: 0;
  margin-right: 1rem;
  margin-bottom: 0.5rem !important;
}

.budget-area {
  min-height: 0px;
}

.loading-state {
  position: absolute;
  inset: 0;
  z-index: 20;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  pointer-events: all;
}

/* Fix horizontal scroll - override any parent overflow restrictions */
.view-item,
.form-inner,
.form-body {
  overflow: visible !important;
}

.budget-title {
  font-weight: 600;
  font-size: 1.25rem !important;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  padding: 15px;
  background-color:var(--table-bg-head);
}

.responsive-table {
  width: 100%;
}

.responsive-table td,
.responsive-table th {
  vertical-align: middle;
}

/* MDA column */
.primary-col {
  max-width: 350px;
  white-space: normal;
  word-break: break-word;
}

/* Economic Line Item column */
.secondary-col {
  max-width: 350px;
  white-space: normal;
  word-break: break-word;
}

/* Amount columns (keep clean and tight) */
.text-end {
  white-space: nowrap;
  min-width: 120px;
}


.sortable-header .th-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.sort-icons {
  display: flex;
  flex-direction: column;
  margin-left: auto;
}

.sort-icon {
  cursor: pointer;
  font-size: 18px;
  line-height: 0.8;
  user-select: none;
}

.sort-icon.active {
  color: #0d6efd;
}

.budget-preview-btn {
  background: #ffffff;
  color: #1f2937;
  border: 1px solid #d1d5db;
  font-weight: 600;
}

.budget-preview-btn:hover {
  background: #f3f4f6;
  color: #111827;
  border-color: #9ca3af;
}

.budget-preview-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
  padding: 1rem;
}

.budget-preview-modal {
  background: #ffffff;
  width: min(1000px, 100%);
  max-height: 85vh;
  border-radius: 8px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.budget-preview-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.9rem 1rem;
  border-bottom: 1px solid #e5e7eb;
}

.budget-preview-body {
  padding: 1rem;
  overflow: auto;
}

/* Responsive adjustments */
@media (max-width: 768px) {

  .table-controls-top {
    flex-direction: column;
    gap: 1rem;
  }
}
</style>
